import axios from 'axios';

export default (postcode) => axios.get(`${process.env.VUE_APP_API_ENDPOINT}/postcode/list/${postcode}`);
